import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e59a783"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "column" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "red" }, "*"),
  /*#__PURE__*/_createTextVNode(" Equipment")
], -1 /* HOISTED */))
const _hoisted_3 = ["data-value", "data-list"]
const _hoisted_4 = { class: "label" }
const _hoisted_5 = { "data-test": "equipment-hierarchy-selectedequipment" }
const _hoisted_6 = { style: {"max-height":"300px","overflow-y":"auto"} }
const _hoisted_7 = {
  key: 0,
  style: {"color":"orange","background":"white","font-style":"italic"}
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 2 }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  style: {"color":"grey","background":"white","font-style":"italic"}
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: "dropdown dense",
      "data-value": _ctx.selectedEquipment,
      "data-list": _ctx.currentOptions,
      "data-test": "equipment-hierarchy-options"
    }, [
      _createElementVNode("div", {
        class: "selector",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggle()))
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.selectedEquipment), 1 /* TEXT */)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["arrow", { expanded: _ctx.visible }])
        }, null, 2 /* CLASS */),
        _createElementVNode("div", {
          class: _normalizeClass({ hidden: !_ctx.visible, visible: _ctx.visible }),
          style: _normalizeStyle([
            _ctx.selectedEquipment ? { paddingTop: '5px' } : { paddingTop: '28px' },
          ])
        }, [
          _createElementVNode("ul", _hoisted_6, [
            (_ctx.paths.length)
              ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paths, (path, index) => {
                      return (_openBlock(), _createElementBlock("span", { key: index }, [
                        (index !== 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, " ≫ "))
                          : _createCommentVNode("v-if", true),
                        (_ctx.haveChildren(path))
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: "path",
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (_ctx.editNode(path, index))
                            }, _toDisplayString(path.equipmentItem), 9 /* TEXT, PROPS */, _hoisted_9))
                          : _createCommentVNode("v-if", true),
                        (!_ctx.haveChildren(path))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(path.equipmentItem), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentOptions, (node, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                onClick: ($event: any) => (_ctx.selectNode(node))
              }, _toDisplayString(node.equipmentItem), 9 /* TEXT, PROPS */, _hoisted_11))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ], 6 /* CLASS, STYLE */)
      ])
    ], 8 /* PROPS */, _hoisted_3),
    (_ctx.paths.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paths, (path, index) => {
            return (_openBlock(), _createElementBlock("span", { key: index }, [
              (index !== 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, " ≫ "))
                : _createCommentVNode("v-if", true),
              (_ctx.haveChildren(path))
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: "path",
                    style: {"cursor":"pointer"},
                    onClick: ($event: any) => (_ctx.editNode(path, index))
                  }, _toDisplayString(path.equipmentItem), 9 /* TEXT, PROPS */, _hoisted_14))
                : _createCommentVNode("v-if", true),
              (!_ctx.haveChildren(path))
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(path.equipmentItem), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}